import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarDisciplinaLayer from "../components/CadastrarDisciplinaLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarDisciplinaPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("disciplina.breadcrumb.create")} />
      <CadastrarDisciplinaLayer />
    </MasterLayout>
  );
};

export default CadastrarDisciplinaPage;
